import {ActionTree} from 'vuex';
import axios, { AxiosResponse } from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, DetailFilterParams, CallGroupIncomingFilterParams, CallGroupFilterParams, CallGroupIncomingItem, DetailIncomingFilterParams, CallGroupItem} from './types';


export const actions: ActionTree<StatisticState, RootState> = {

  async getCallStatisticDetail({commit, dispatch}, data: DetailFilterParams) {
    commit('setLoading', true);
    try {
      let resp = await axios({
        url: '/stats-api/detail/call',
        params: data,
      });
      let messages = resp.data?.messages ?? [];
      if (data.page_number > 1) {
        commit('pushCallStatisticDetail', messages);
      } else {
        commit('setCallStatisticDetail', messages);
      }
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportCallStatisticDetail({commit, dispatch}, data: DetailFilterParams) {
    commit('setLoading', true);
    try {
      let resp = await axios({
        url: '/stats-api/detail/call/export',
        params: data,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  async getCallStatisticGroup({commit}, data: CallGroupFilterParams) {
    commit('setLoading', true);
    try {
      const resp: AxiosResponse<{messages_count: number, messages: CallGroupItem[]}> = await axios({
        url: '/stats-api/group/call',
        params: data,
      });
      commit('setCallStatisticGroup', resp.data.messages);
      commit('setCallMessagesCount', resp.data.messages_count);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportCallStatisticGroup({commit}, data: CallGroupFilterParams) {
    commit('setLoading', true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        url: '/stats-api/group/call/export',
        params: data,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  async getCallStatisticGroupIncoming({commit}, filterParams: CallGroupIncomingFilterParams) {
    commit('setLoading', true);
    try {
      let resp: AxiosResponse<{messages_count: number, messages: CallGroupIncomingItem[]}> = await axios({
        url: '/stats-api/group/call',
        params: filterParams,
      });
      commit('setCallStatisticGroupIncoming', resp.data.messages);
      commit('setCallIncomingMessagesCount', resp.data.messages_count);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportCallStatisticGroupIncoming({commit}, filterParams: CallGroupIncomingFilterParams) {
    commit('setLoading', true);
    try {
      let resp: AxiosResponse<{status: string}> = await axios({
        url: '/stats-api/group/call/export',
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },

  async getCallStatisticDetailIncoming({commit, dispatch}, data: DetailIncomingFilterParams) {
    commit('setLoading', true);
    try {
      let resp = await axios({
        url: '/stats-api/detail/call',
        params: data,
      });
      let messages = resp.data?.messages ?? [];
      if (data.page_number > 1) {
        commit('pushCallStatisticDetailIncoming', messages);
      } else {
        commit('setCallStatisticDetailIncoming', messages);
      }
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  async getCallStatisticDetailIncomingInfo({commit, dispatch}, id: string) {
    commit('setLoading', true);
    try {
      const resp = await axios({
        url: '/stats-api/detail/call/'.concat(id),
      });
      const data = resp.data;
      return data;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportCallStatisticDetailIncoming({commit, dispatch}, data: DetailIncomingFilterParams) {
    commit('setLoading', true);
    try {
      let resp = await axios({
        url: '/stats-api/detail/call/export',
        params: data,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
};
